$(function () {
    var $toggles = $('.togglable-block__toggle, .togglable-block__show-all');
    var shownClass = 'togglable-block_shown';

    var toggle = function ($toggle, $slideable, show) {
        var $icon = $toggle.find('.togglable-block__icon');

        if ($toggle.hasClass('togglable-block__toggle')) {
            var text = $toggle.data('text');
            if (Boolean(text)) {
                $toggle.html(show ? text.less : text.more);
            }
        }

        if ($icon.length > 0) {
            $icon
                .toggleClass($icon.data('icon').show, !show)
                .toggleClass($icon.data('icon').hide, show);
        }

        $slideable.toggleClass(shownClass, show);

        if ($toggles.is('.togglable-block__toggle_eventable')) {
            $(document)
                .trigger('TogglableBlock::toggled.VendorProfileHeader', [show]);
        }
    };

    $(document)
        .on('click.TogglableBlock', $toggles.selector, function () {
            var $toggle = $(this);
            var $slideable = $(this)
                .parents('.togglable-block');

            toggle($toggle, $slideable, !$slideable.hasClass(shownClass));
        });

    $(document)
        .on('TogglableBlock::hide', function (event, $slideable) {
            var $toggle = $slideable.find('.togglable-block__toggle');
            toggle($toggle, $slideable, false);
        });
});
